import { useStableCallback } from "@bezoned/shared/hooks/use-stable-callback.js";
import type { TeamMember } from "@bezoned/shared/types/api/team/team-member-list.types.js";
import { Button } from "@fluentui/react-components";
import { useMemo } from "react";

import type { OrganizationUser } from "../../tabs/members/components/team-add-members-dialog.js";
import { TeamMembersTab } from "../../tabs/members/team-members-tab.js";

export interface SelectedMember {
  msUserId: string;
  displayName: string;
  email: string;
}

interface TeamCreateMembersTabProps {
  currentUserDisplayName: string;
  currentUserEmail: string;
  currentUserId: string;
  members: SelectedMember[];
  onAddAllOrganizationUsers: () => void;
  onAddMembers: (members: SelectedMember[]) => void;
  onRemoveMember: (member: SelectedMember) => void;
  onBack: () => void;
  onContinue: () => void;
  continueLabel?: string;
  submitting?: boolean;
}

export const TeamCreateMembersTab = ({
  currentUserDisplayName,
  currentUserEmail,
  currentUserId,
  members,
  onAddAllOrganizationUsers,
  onAddMembers,
  onRemoveMember,
  onBack,
  onContinue,
  continueLabel = "Continue",
  submitting = false,
}: TeamCreateMembersTabProps) => {
  const membersWithCurrentUser = useMemo(() => {
    const currentUserRow = {
      displayName: currentUserDisplayName,
      email: currentUserEmail,
      id: currentUserId,
      userId: currentUserId,
    };

    const otherMembers = members
      .filter((member) => member.msUserId !== currentUserId)
      .map((member) => ({
        displayName: member.displayName,
        email: member.email,
        id: member.msUserId,
        userId: member.msUserId,
      }));

    return [currentUserRow, ...otherMembers];
  }, [currentUserDisplayName, currentUserEmail, currentUserId, members]);
  const handleRemoveUser74 = useStableCallback((user: TeamMember) => {
    if (user.id === currentUserId) {
      return;
    }

    onRemoveMember({
      displayName: user.displayName,
      email: user.email,
      msUserId: user.id,
    });
  });

  const handleAddUsers65 = useStableCallback((users: OrganizationUser[]) => {
    onAddMembers(
      users.map((user) => ({
        displayName: user.displayName,
        email: user.email,
        msUserId: user.id,
      }))
    );
  });

  return (
    <div className="flex min-h-full w-full flex-col">
      <div className="flex-1">
        <TeamMembersTab
          allowAddAllTeamsUsersAction
          currentUserId={currentUserId}
          errorMessage={null}
          isLoading={false}
          isSaving={submitting}
          members={membersWithCurrentUser}
          onAddAllTeamsUsers={onAddAllOrganizationUsers}
          onAddUsers={handleAddUsers65}
          onRemoveUser={handleRemoveUser74}
          persistPaginationInQuery={false}
        />
      </div>

      <div className="mt-auto flex justify-end gap-3 pt-4">
        <Button
          appearance="secondary"
          disabled={submitting}
          onClick={onBack}
          type="button"
        >
          Back
        </Button>
        <Button
          appearance="primary"
          disabled={submitting}
          onClick={onContinue}
          type="button"
        >
          {continueLabel}
        </Button>
      </div>
    </div>
  );
};
